<template>
  <div ref="mapElement" style="width: 100%; height: 400px"></div>
</template>

<script lang="ts">
import { importLibrary } from '@googlemaps/js-api-loader'
import { defineComponent, ref, onMounted } from 'vue'
import { useTrackingStore } from '@/store/modules/tracking'

/* global google */
export default defineComponent({
  name: 'GMapWithMarker',
  props: {
    apiKey: { type: String, required: true },
    lat: { type: Number, required: true },
    lng: { type: Number, required: true },
    zoom: { type: Number, default: 18 },
    markerTitle: { type: String, required: true },
  },
  setup(props) {
    const mapElement = ref<HTMLElement | null>(null)
    const trackingStore = useTrackingStore()

    onMounted(async () => {
      const { apiKey, lat, lng, zoom, markerTitle } = props

      trackingStore.initGoogleMaps(apiKey)

      const { Map } = (await importLibrary('maps')) as google.maps.MapsLibrary
      const { AdvancedMarkerElement } = (await importLibrary('marker')) as google.maps.MarkerLibrary

      const map = new Map(mapElement.value!, { zoom, center: { lat, lng }, mapId: 'roadmap' })

      new AdvancedMarkerElement({ map, position: { lat, lng }, title: markerTitle })
    })

    return { mapElement }
  },
})
</script>
